import type { TFunction } from 'i18next';

export const getOrderProductSaveErrorMessage = (error: unknown, fallback: string) => {
  const responseData = (error as { response?: { data?: { message?: unknown; error?: unknown } } })?.response?.data;
  const candidate = responseData?.message ?? responseData?.error;
  return typeof candidate === 'string' && candidate.trim() ? candidate.trim() : fallback;
};

export interface OrderProductDeleteCargoConflictResponse {
  code?: unknown;
  routeNumbers?: unknown;
  productNames?: unknown;
}

const toStringList = (value: unknown): string[] =>
  Array.isArray(value) ? value.filter((item): item is string => typeof item === 'string') : [];

// S32 (order-product delete guard): PUT /orders/:id/products answers 400
// ORDER_PRODUCT_HAS_TRANSPORT_CARGO when the payload would delete a line that
// is still loaded on a transport (see orderProductsService
// .assertDeletableWithoutOrphaningCargo). The backend's `message` is an
// English sentence meant for logs/API consumers — map the stable `code` to
// Polish-first copy here instead of echoing it, same pattern as
// transportRouteViews.mapTransportMutationErrorToMessage. Returns undefined
// for any other error so callers fall through to
// getOrderProductSaveErrorMessage's generic message/fallback handling.
export const getOrderProductDeleteCargoConflictMessage = (
  t: TFunction,
  error: unknown,
): string | undefined => {
  const responseData = (error as { response?: { data?: OrderProductDeleteCargoConflictResponse } })
    ?.response?.data;

  if (responseData?.code !== 'ORDER_PRODUCT_HAS_TRANSPORT_CARGO') {
    return undefined;
  }

  return t('orders:orderDetail.messages.productHasTransportCargoError', {
    products: toStringList(responseData.productNames).join(', '),
    routes: toStringList(responseData.routeNumbers).join(', '),
  });
};
